// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text-caption[data-v-3283e0cc] {\n  font-size: 0.75rem !important;\n}\n.manual-adjustment-table[data-v-3283e0cc] tbody tr {\n  height: 60px !important;\n}\n.manual-adjustment-table[data-v-3283e0cc] tbody td {\n  padding-top: 4px !important;\n  padding-bottom: 4px !important;\n}\n", ""]);
// Exports
module.exports = exports;
